import { DatePipe, NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recent-news',
  standalone: true,
  imports: [NgFor, DatePipe],
  templateUrl: './recent-news.component.html',
  styleUrl: './recent-news.component.scss'
})
export class RecentNewsComponent {
  @Input() data:any; 
  @Input() total:any; 

  constructor(private router: Router) { }

  ngOnInit(): void { }

  goToNewsDetail(_id:any){    
    this.router.navigate(['/discovery-updates', _id]);
  }

}
